/**
 * Badge Service
 */
import { getApiClient } from '../apiClient';
import { BADGE_ENDPOINTS, replacePathParams } from '../endpoints';
import type {
  GetBadgesResponse,
  GetBadgeResponse,
  CreateBadgePayload,
  CreateBadgeResponse,
  UpdateBadgePayload,
  UpdateBadgeResponse,
  DeleteBadgeResponse,
  GetBadgesParams,
} from '../types/badge.types';

export const badgeService = {
  /**
   * Get all badges
   * @param params - Optional query params (search, pagination)
   */
  getBadges: (params?: GetBadgesParams): Promise<GetBadgesResponse> => {
    const queryParams = new URLSearchParams();
    if (params?.search) {
      queryParams.append('search', params.search);
    }
    if (params?.page) {
      queryParams.append('page', String(params.page));
    }
    if (params?.limit) {
      queryParams.append('limit', String(params.limit));
    }
    if (params?.offset) {
      queryParams.append('offset', String(params.offset));
    }
    const url = queryParams.toString() 
      ? `${BADGE_ENDPOINTS.getBadges}?${queryParams.toString()}`
      : BADGE_ENDPOINTS.getBadges;
    return getApiClient().get(url);
  },

  /**
   * Get single badge by ID
   */
  getBadge: (id: string): Promise<GetBadgeResponse> => {
    const url = replacePathParams(BADGE_ENDPOINTS.getBadge, { id });
    return getApiClient().get(url);
  },

  /**
   * Create badge
   */
  createBadge: (body: CreateBadgePayload): Promise<CreateBadgeResponse> => {
    return getApiClient().post(BADGE_ENDPOINTS.createBadge, body);
  },

  /**
   * Update badge
   */
  updateBadge: (id: string, body: UpdateBadgePayload): Promise<UpdateBadgeResponse> => {
    const url = replacePathParams(BADGE_ENDPOINTS.updateBadge, { id });
    return getApiClient().put(url, body);
  },

  /**
   * Delete badge
   */
  deleteBadge: (id: string): Promise<DeleteBadgeResponse> => {
    const url = replacePathParams(BADGE_ENDPOINTS.deleteBadge, { id });
    return getApiClient().delete(url);
  },
};

